import * as React from 'react';
import { ICategoryContent } from 'src/model/category.model';
import './CategoriesMobileMenu.scss';
import CategoriesMobileSubmenu from './components/CategoriesMobileSubmenu';
import i18n from 'src/translation/i18n';

interface ICategoriesMobileMenuProps {
  mounted: boolean;
  categories: ICategoryContent[];
  getCategories: () => void;
  handleCloseMenu: () => void;
  handleCloseAll: () => void;
}

export class CategoriesMobileMenu extends React.Component<
  ICategoriesMobileMenuProps,
  any
> {
  constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    this.props.getCategories();
  }

  public render() {
    return (
      <div className="rp-categories-mobile">
        <div className="rp-categories-menu">
          <CategoriesMobileSubmenu
            mounted={this.props.mounted}
            level={2}
            // goBackTitle={'Home'}
            menuTitle={i18n.t('common.shopByCategories')}
            categories={this.props.categories}
            handleCloseMenu={this.props.handleCloseMenu}
            handleCloseAll={this.props.handleCloseAll}
          />
        </div>
      </div>
    );
  }
}

export default CategoriesMobileMenu;
